import { createConsumer } from "@rails/actioncable";

const consumer = createConsumer();

export default {
  install(app) {
    app.config.globalProperties.$cable = consumer;
  }
};
